// @flow
import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation ExecuteCSVImportMutation($input: ExecuteCSVImportInput!) {
    executeCSVImport(input: $input) {
      csvImport {
        csvImportId
        status
        importedCount
        updatedCount
        skippedCount
        skippedDetails
        errorMessage
      }
    }
  }
`;

export default ({ variables }: Object) =>
  createRelayMutation(mutation, { variables });
